import { AccountFeatureSettings, AccountIntegrationSettings, EditableIntegration } from 'generated/types/HelloRequest';
import { queryParams } from 'hellospa/common/utils/fetch';
import hsFetch, { getCSRFToken } from 'hellospa/hs-fetch';

// TODO: DEV-18967 will define this schema.
export type AccountSettingsPageSchema = {
  // Things the user CAN NOT change with formik
  permissions: {
    isBrandingEnabled : AccountFeatureSettings['enabledFeatures']['isBrandingEnabled']
    hasSubscriptionAccess : AccountFeatureSettings['hasSubscriptionAccess']
    shouldEnableInPersonSigning : AccountFeatureSettings['shouldEnableInPersonSigning']

    // this isn't exactly a permission, but it's something the user can't
    // change.
    isAccountLogoTeamLogo : AccountFeatureSettings['isAccountLogoTeamLogo']

    // The URL is not changed by the user. They may submit an image
    // and we will generate a new URL.
    customLogoUrl: AccountFeatureSettings['customLogoUrl']
  }

  features: AccountFeatureSettings
}
type ExcludeFromSaveData = 'permissions' | 'user'
export type AccountSettingsSaveData = Omit<AccountSettingsPageSchema, ExcludeFromSaveData>

export async function fetchAccountSettingsData() {
  const url = '/accountSettings/data';
  const result = await hsFetch(url);

  const data: AccountSettingsPageSchema = await result.json();

  return data;
}

export async function updateEditableIntegration(
  integration: EditableIntegration,
): Promise<AccountIntegrationSettings> {
  const url = '/TODO/DEV-17960';
  const result = await hsFetch(url, {
    method: 'POST',
    body: JSON.stringify(integration),
  });

  const data: AccountIntegrationSettings = await result.json();

  return data;
}

export async function save(
  settings: AccountSettingsSaveData,
  f?: File,
): Promise<AccountSettingsPageSchema> {

  const formData = new FormData();
  formData.append('data', JSON.stringify(settings));
  if (f) {
    formData.append('customLogoFile', f);
  }

  const url = '/accountSettings/data';
  const result = await hsFetch(url, {
    method: 'POST',
    body: formData,
  });
  const data: AccountSettingsPageSchema = await result.json();

  return data;
}

export async function removeCustomLogo(forTeam: boolean): Promise<void> {
  // This URL doesn't return any data
  const url = `/content/removeCustomLogo${queryParams({
    for_team: (forTeam ? '1' : '0'),
  })}`;
  await hsFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      csrf_token: getCSRFToken(),
    }),
  });
}
